// extracted by mini-css-extract-plugin
module.exports = {"Container":"ThermometerGauge_Container__3Lpbw","Title":"ThermometerGauge_Title__1K9Fr"};